<template>
    <div class="accordion-item">
        <h2 class="accordion-header" :id="'headingThree' + id">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseThree' + id" aria-expanded="false" :aria-controls="'collapseThree' + id">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-right: 4px;">
              <slot name="title"></slot>
            </div>
          </button>
        </h2>
        <div :id="'collapseThree' + id" class="accordion-collapse collapse" :aria-labelledby="'headingThree' + id" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <slot name="body"></slot>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"AccordionItem",
    props: {
        id:{
            type:Number,
            required: true
        }
    }    
}
</script>
